
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class KutuphaneByCriteriaAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "Kutuphane/KutuphaneByCriteria";
        super(baseUrl);
    }


    KutuphaneByCriteria(request: KutuphaneByCriteriaRequest) {

        return this.post("", request);

    }

}
export default new KutuphaneByCriteriaAPI();

class KutuphaneByCriteriaRequest {
    basimTar?: Date;
    basimTar2?: Date;
    basimNumarasi?: string;
    kayitNo?: number;
    eserAdi?: string;
    yazarAdi?: string;
    yayineviAdi?: string;
    barkodKodu?: string;
    katalogTipi?: number;
    yerKodu?: number;
    katalogKonusu?: number;
    dilKodu?: number;

    constructor(
        basimTar?: Date,
        basimTar2?: Date,
        basimNumarasi?: string,
        kayitNo?: number,
        eserAdi?: string,
        yazarAdi?: string,
        yayineviAdi?: string,
        barkodKodu?: string,
        katalogTipi?: number,
        yerKodu?: number,
        katalogKonusu?: number,
        dilKodu?: number
    ) {
        this.basimTar = basimTar;
        this.basimTar2 = basimTar2;
        this.basimNumarasi = basimNumarasi;
        this.kayitNo = kayitNo;
        this.eserAdi = eserAdi;
        this.yazarAdi = yazarAdi;
        this.yayineviAdi = yayineviAdi;
        this.barkodKodu = barkodKodu;
        this.katalogTipi = katalogTipi;
        this.yerKodu = yerKodu;
        this.katalogKonusu = katalogKonusu;
        this.dilKodu = dilKodu;
    }
}
export { KutuphaneByCriteriaRequest };